/**
 * IMPORTS
 */
import {t} from 'i18next';
import Store from 'src/store';


/**
 * TYPES
 */
import {IAgent} from 'src/aggregates/agents/state.d';
import {IAgentById} from 'src/aggregates/agents/state.d';
import {IPeriod} from 'src/aggregates/agents/state.d';
import {Role} from 'src/aggregates/agents/state.d';


/**
 * CODE
 */

/**
 * I get an agent from a given id.
 *
 * :param id: agent id to be fetched
 *
 * :returns: agent
 */
function fetch(id: number): IAgent | null
{
    // get agent of given id
    const agent = Store.getState().agent.byId[id];

    // agent does not exist: return null
    if (agent === undefined)
    {
        return null;
    }

    // agent exists: return it
    return agent;
}

/**
 * I get all agents.
 *
 * :returns: agents
 */
function fetchAll (): IAgentById
{
    return Store.getState().agent.byId;
}

/**
 * I get agents who have the role
 *
 * :param role: role
 *
 * :returns: agents
 */
function fetchByRole (role: Role): IAgent[]
{
    // get agents
    const agents = Object.values(Store.getState().agent.byId);

    // return agents
    return agents.filter(agent => agent.roles[role] === true);
}

/**
 * I get the name of an agent
 *
 * :param uid: agent uid
 *
 * :returns: name of agent
 */
function getAgentName (uid: string): string
{
    // is a system uid: return system placeholder
    if (uid === 'system' || uid === '0')
    {
        return t('Sistema');
    }

    // otherwise: return agent name or uid
    return Store.getState().agent.byId[uid]?.fullname ?? uid.toString();
}

/**
 * I get the selected metrics period.
 *
 * :returns: selected period
 */
function getPeriod (): IPeriod
{
    // get period from store
    const {end, start} = Store.getState().agent.metrics;

    // return period
    return {end, start};
}


/**
 * EXPORTS
 */
export {
    fetch,
    fetchAll,
    fetchByRole,
    getAgentName,
    getPeriod,
};
